import React from 'react';
import {useIntl} from 'react-intl';

import AddressModel from 'coreOrderModels/AddressModel';
import ShipmentModel from 'coreOrderModels/ShipmentModel';

import {useGeneralProvider} from 'brandComponents/_app-config/GeneralProvider';
import Grid from 'brandComponents/Grid';
import ProductData from 'brandComponents/ReturnAuthorizationCreateForm/Subcomponents/ProductData';
import Typography from 'brandComponents/Typography';

import ReturnExchange from './Subcomponents/ReturnExchange';
import {IProductLineProps} from './IProductLine';
import messages from './messages';

import styles from '../../Step1.module.scss';

const ProductLine = ({returnOrder, step, products, returnReasons, exchangeReasons}: IProductLineProps) => {
	const {managerRepository} = useGeneralProvider();
	const intl = useIntl();

	const shipment: ShipmentModel = returnOrder.getShipments()?.[0] || null;

	const shippingAddress: AddressModel = shipment?.getShippingAddress() || null;

	return (
		<>
			{returnOrder.getProductItems(true).map((item, index) => {
				const itemKey = item.getItemId() + '_' + index;

				const shipmentCountryCode = returnOrder.getShipments()[0].getShippingAddress().getCountryCode();
				const returnUnavailableByCountryCode = managerRepository
					.getProductsMgr()
					.getProduct(item.getProductId())
					.getNoReturnCountries()
					.includes(shipmentCountryCode);
				const isBonus = item.isBonus();

				return (
					<Grid.Row classNames={styles['return-create-step-1__row']} key={itemKey}>
						<Grid.Column sm={6}>
							<ProductData
								item={item}
								step={step}
								product={products[index]}
								shippingCountryCode={shippingAddress?.getCountryCode()}
								quantity={1}
								currency={returnOrder.getCurrency()}
								isBonus={isBonus}
							/>
						</Grid.Column>
						{returnUnavailableByCountryCode ? (
							<Typography classNames={styles['return-create-step-1__return-unavailable']} variant="p">
								{intl.formatMessage(messages.returnNotAvailable)}
							</Typography>
						) : (
							<Grid.Column classNames={styles['return-create-step-1__column']} sm={6}>
								{!isBonus && (
									<ReturnExchange
										product={products[index]}
										itemKey={itemKey}
										returnReasons={returnReasons}
										shippingCountryCode={shippingAddress?.getCountryCode()}
										exchangeReasons={exchangeReasons}
									/>
								)}
							</Grid.Column>
						)}
					</Grid.Row>
				);
			})}
		</>
	);
};

export default ProductLine;
